var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarStype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 205,
    viewBox: "0 0 500 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.348 183.24C53.8398 183.665 58.1266 183.904 58.1266 183.904L58.1685 183.862L58.7593 183.904C60.578 184.06 62.5475 184.271 64.3661 184.361C70.3836 184.753 76.51 185.075 82.5401 185.19C89.0813 185.392 95.7315 185.479 102.273 185.479C105.047 185.496 108.018 185.359 110.792 185.273C111.886 185.178 113.729 184.58 114.723 184.263L114.924 186.39H114.928C114.625 186.426 114.327 186.495 114.04 186.597C113.773 186.664 113.526 186.793 113.319 186.972C113.278 187.01 113.246 187.055 113.225 187.105C113.203 187.156 113.192 187.21 113.193 187.265C113.417 189.35 113.798 191.417 114.333 193.447C114.492 194.094 114.656 194.742 114.832 195.385C114.991 195.958 115.154 196.527 115.339 197.092C115.475 197.568 115.661 198.03 115.892 198.47C116.805 200.045 118.117 202.519 119.307 203.822C119.395 203.928 119.504 204.016 119.627 204.079C119.75 204.143 119.885 204.182 120.023 204.194L120.824 204.235C121.079 204.235 122.777 202.68 122.927 202.416C122.977 202.341 123.004 202.253 123.006 202.164C123.007 202.074 122.983 201.986 122.936 201.909H122.978L123.275 202.074H123.317L124.771 201.418C124.779 201.422 124.786 201.426 124.792 201.431C125.111 201.307 124.977 200.923 125.002 200.659C124.298 197.335 122.768 191.892 121.934 188.543C121.926 188.514 121.918 188.49 121.909 188.461L121.515 187.298C121.479 187.191 121.41 187.097 121.318 187.03L120.438 186.386C120.363 186.329 120.278 186.284 120.187 186.254L119.609 186.044C119.413 185.444 119.359 184.808 119.454 184.184H119.919L154.817 184.11C173.275 184.465 211.392 184.827 211.392 184.827C243.721 185.071 280.664 185.223 318.327 185.195L333.677 185.248C333.677 185.248 432.832 184.654 474.221 183.718C475.109 183.698 476.597 183.693 476.597 183.693C476.731 183.751 476.828 183.858 476.974 183.858C480.452 183.541 485.464 183.108 488.783 182.155H489.248C489.248 182.155 489.457 182.188 489.587 181.866C489.587 181.866 490.815 181.479 490.891 181.45C490.891 181.45 491.829 181.203 492.072 180.91L492.294 180.695L492.403 180.58L492.768 179.837C493.653 177.909 494.303 175.883 494.704 173.804C496.539 169.796 497.524 164.946 498.107 160.504C498.165 160.067 498.199 159.667 498.228 159.308C499.364 144.743 500.29 117.801 500.177 103.594V100.88C500.269 86.5575 499.347 60.0446 498.228 45.6355C498.199 45.2767 498.165 44.8766 498.107 44.4395C497.524 39.998 496.539 35.1482 494.704 31.1397C494.303 29.0604 493.653 27.0351 492.768 25.1064L492.403 24.364L492.294 24.2486L492.072 24.0341C491.829 23.7413 490.891 23.4939 490.891 23.4939C490.811 23.465 489.587 23.0815 489.587 23.0774C489.457 22.7557 489.248 22.7846 489.248 22.7846H488.783C485.464 21.8361 480.452 21.403 476.974 21.0855C476.828 21.0855 476.727 21.1927 476.597 21.2505C476.597 21.2505 475.109 21.2422 474.221 21.2257C432.832 20.2896 333.677 19.6957 333.677 19.6957L318.327 19.7493C280.664 19.7246 243.721 19.873 211.392 20.1164C211.392 20.1164 173.271 20.4751 154.817 20.8339L119.919 20.7597H119.454C119.36 20.1376 119.413 19.5026 119.609 18.9039L120.187 18.6895C120.276 18.6563 120.361 18.6119 120.438 18.5575L121.318 17.9142C121.411 17.8479 121.481 17.7539 121.515 17.6461L121.909 16.4831C121.918 16.4543 121.926 16.4295 121.934 16.4007C122.768 13.052 124.294 7.60425 125.002 4.28446C124.977 4.02053 125.111 3.64112 124.792 3.51328C124.784 3.51484 124.777 3.51923 124.771 3.52565L123.317 2.86994H123.275L122.978 3.0349H122.936C122.983 2.95808 123.007 2.86979 123.006 2.78009C123.004 2.6904 122.977 2.60292 122.927 2.52765C122.777 2.26372 121.079 0.708984 120.824 0.708984L120.023 0.750224C119.885 0.761909 119.75 0.800767 119.627 0.864511C119.504 0.928254 119.395 1.01559 119.307 1.12138C118.117 2.42868 116.805 4.90306 115.892 6.47429C115.661 6.91396 115.475 7.37543 115.339 7.85169C115.154 8.41667 114.987 8.98578 114.832 9.55901C114.656 10.2023 114.492 10.8457 114.333 11.4973C113.8 13.5277 113.419 15.5939 113.193 17.6791C113.192 17.7338 113.203 17.788 113.225 17.8384C113.246 17.8888 113.278 17.9343 113.319 17.9719C113.526 18.1504 113.773 18.2789 114.04 18.3472C114.326 18.4494 114.625 18.5172 114.928 18.5493H114.924L114.735 20.6937C113.742 20.3803 111.886 19.7699 110.792 19.6751C108.018 19.5885 105.047 19.4524 102.273 19.4689C95.7315 19.4689 89.0771 19.5596 82.5401 19.7576C76.5058 19.873 70.3836 20.1947 64.3661 20.5865C62.5475 20.6731 60.578 20.8875 58.7593 21.0443L58.1685 21.0855L58.1266 21.0443C58.1266 21.0443 53.8398 21.2834 52.348 21.7082M52.4737 21.667C50.8771 21.8233 49.297 22.1144 47.7511 22.5371C46.0707 23.2176 43.2505 24.3104 41.5953 25.0692L41.3397 25.1105L35.1421 26.026C28.6762 26.7972 21.9296 28.4633 17.052 32.9543C14.1564 35.6884 11.9145 39.1979 10.1797 42.7487C7.55644 47.8418 5.24752 53.4297 3.89401 58.9765C3.89401 58.9765 3.68029 59.1291 3.39115 60.0982C2.59078 62.5066 2.42735 67.4059 2.16755 69.8926C1.85327 74.1815 1.42165 78.7962 1.07384 83.0893C0.384292 89.5267 0.100197 96 0.223187 102.472C0.10029 108.944 0.384385 115.417 1.07384 121.855C1.42165 126.148 1.85327 130.762 2.16755 135.051C2.42735 137.538 2.59078 142.437 3.39115 144.846C3.68448 145.815 3.89401 145.967 3.89401 145.967C5.24752 151.514 7.55644 157.102 10.1797 162.195C11.9145 165.746 14.1564 169.255 17.052 171.99C21.9296 176.485 28.6762 178.147 35.1421 178.918L41.3397 179.833L41.5953 179.875C43.2505 180.633 46.0707 181.726 47.7511 182.407C49.2961 182.833 50.8765 183.125 52.4737 183.277",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M425.777 41.4824V163.445H469.986L473.425 132.727L475.149 101.397L473.425 70.9094L469.986 41.4824H425.777Z",
    fill: "#ECECEC",
    stroke: "#707070",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M484.492 41.1982V41.5282L484.786 41.8622L485.381 44.9304L488.578 73.2291L489.642 101.68V101.705L488.578 130.136L485.381 158.434L484.786 161.544",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M485.447 34.167C485.447 34.167 484.341 35.664 484.923 38.1384L485.724 41.3757V41.7675C485.724 41.7675 487.169 49.0545 488.041 55.958C489.892 70.9411 490.75 86.0268 490.61 101.12V101.701L490.606 104.151L490.564 107.883L490.396 115.314L490.182 121.084L489.931 126.519L489.591 131.789L489.21 136.85L488.749 141.539L488.326 145.481L487.819 149.217L487.312 152.789L486.851 155.733L486.344 158.554L486.176 159.259L486.051 160.01L485.753 161.544",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M475.09 42.6045L478.513 72.4414L479.657 102.447L478.513 132.453L475.09 162.29",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M472.055 42.6455L475.47 72.4494L476.61 102.426V102.447L475.47 132.399L472.055 162.203",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M469.828 163.325L473.415 133.257L475.024 102.385L473.415 71.5131L469.828 41.4453",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8346 175.103C77.056 169.577 73.1757 162.142 70.7746 154.644C66.3118 138.499 64.5266 118.922 65.2935 102.229C64.732 84.4956 66.2154 63.8016 71.9982 46.9098C73.6565 42.3727 75.9711 38.0947 78.8705 34.208C80.0271 32.7174 81.2813 31.3026 82.6251 29.9727L83.0064 29.6428C83.0064 29.6428 84.0163 28.7272 84.0163 28.7314C84.0497 28.683 84.0645 28.6245 84.0582 28.5664H84.0163",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9875 159.833C61.6961 141.828 61.4321 119.81 61.4321 102.481C61.4321 85.1519 61.6961 63.1341 68.9875 45.1288C69.5364 44.003 70.8983 41.0997 71.5646 40.0646C72.1219 38.8686 71.2461 37.9201 69.9471 38.4191C67.6591 39.1779 63.4184 40.044 60.8036 40.9884C59.1986 41.5698 58.7251 42.0606 57.799 43.1741C54.7903 48.0362 52.1629 58.1977 51.6517 61.2247C49.305 73.3367 49.217 87.152 49.3385 102.481C49.217 117.81 49.305 131.625 51.6517 143.737C52.1629 146.764 54.7903 156.925 57.799 161.788C58.7209 162.901 59.1986 163.392 60.8036 163.973C63.4184 164.922 67.6591 165.788 69.9471 166.542C71.2461 167.041 72.1261 166.097 71.5646 164.897C70.8941 163.862 69.5364 160.959 68.9875 159.833Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4366 102.48C62.4199 85.1097 62.378 55.0254 74.1489 36.6201L61.7075 39.9399C60.2284 40.2819 58.8554 40.9709 57.7056 41.9483C57.2771 42.3389 56.9261 42.8046 56.6706 43.3216C48.1431 60.304 48.2227 81.6043 48.2227 102.476C48.2227 123.347 48.1431 144.656 56.6706 161.634C56.9251 162.152 57.2762 162.617 57.7056 163.007C58.8554 163.985 60.2284 164.674 61.7075 165.016L74.1489 168.335C62.378 149.93 62.4199 119.846 62.4366 102.476V102.48Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98294 103.034C2.46065 109.038 3.72616 129.893 4.29606 133.802C5.35624 138.908 7.58974 144.24 11.3611 147.989V147.948L11.403 147.906H11.4449L11.6126 148.071L11.7383 148.03C11.774 147.971 11.8162 147.916 11.864 147.865C11.9616 147.373 11.9758 146.869 11.9059 146.372C11.6084 143.65 10.7787 139.126 10.4728 136.413C9.33296 128.305 8.63315 119.769 8.32306 111.595C8.20992 109.467 7.89983 102.473 7.89983 102.473C7.89983 102.473 8.20992 95.4785 8.32306 93.3505C8.63315 85.1768 9.33715 76.6402 10.4728 68.5325C10.7787 65.8189 11.6084 61.2949 11.9059 58.5731C11.9737 58.0765 11.9596 57.5724 11.864 57.0802C11.8152 57.0306 11.773 56.9752 11.7383 56.9153L11.6126 56.874L11.4449 57.039H11.403L11.3611 56.9977V56.9565C7.59393 60.7011 5.35624 66.0333 4.29606 71.1429C3.72197 75.0525 2.45646 95.9073 1.98294 101.912C1.9536 102.287 1.9536 102.663 1.98294 103.038V103.034Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.932 38.2168H200.055V41.4747H209.932V38.2168Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.935 163.485H200.066V166.764H209.935V163.485Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4204 27.2832C86.4078 27.3409 86.3282 27.3945 86.3366 27.4482C103.274 28.4998 120.799 30.4999 137.573 33.0114C137.544 33.2918 137.917 33.9269 137.996 34.4218C138.114 35.0651 137.489 35.993 137.363 36.6199",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0479 82.5205V82.6442C89.9506 82.7956 89.8204 82.9238 89.6666 83.0195C89.2769 83.0813 87.2277 83.4278 86.8422 83.4772C86.7015 83.5254 86.5481 83.5228 86.4091 83.4699C86.2702 83.417 86.1549 83.3173 86.0837 83.1886C86.0466 82.9402 86.0326 82.6889 86.0418 82.438L86.7081 71.1054L88.3717 59.8717L91.0159 48.8236C91.0592 48.6306 91.1634 48.456 91.3134 48.3246C91.7283 48.1885 93.0524 48.0689 93.505 47.9905C93.6495 47.9827 93.7937 48.0111 93.924 48.073C93.9605 48.1381 93.9887 48.2073 94.0079 48.2792C91.7199 59.4552 90.6806 71.1425 90.0437 82.5164L90.0479 82.5205Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0938 24.669C47.4584 23.565 49.8795 22.5822 52.3474 21.7245C53.8392 21.2997 58.126 21.0605 58.126 21.0605L58.1679 21.1018V21.2379",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5938 25.0859C43.249 24.3271 46.0691 23.2342 47.7495 22.5538C49.2945 22.1271 50.8749 21.8359 52.4721 21.6836",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.524 30.6863C137.744 30.2326 113.691 27.4572 110.201 26.7025C109.324 26.4786 108.475 26.1591 107.67 25.7499L106.953 25.3333C106.852 25.3004 106.723 25.2591 106.609 25.2344",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.06 25.1266C96.1092 24.409 92.0613 23.8399 84.0156 28.5701",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M199.473 30.6862L203.99 30.6738V30.6862L204.116 30.7316L204.199 30.8099L204.241 30.8924V37.0371L204.199 37.1608L204.116 37.2845H203.99L202.008 37.2887L199.519 37.2433",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M333.687 19.708L333.615 19.7822L333.574 19.906L333.527 31.8984L333.318 32.5212L204.24 32.7315L204.282 20.3637L204.156 20.1534",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M141.831 30.6855C155.081 30.8959 185.918 30.7103 199.474 30.6855L199.516 37.2426C187.515 37.156 175.363 36.855 163.378 36.1622C159.087 35.857 154.67 35.5312 150.392 35.1271C146.591 34.7188 141.944 34.0466 138.164 33.3826V33.1352C139.118 32.1125 140.263 31.2808 141.537 30.6855H141.831Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3242 34.2985C36.2845 34.3563 70.227 31.2798 77.8201 30.9375",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4258 45.252C25.1358 42.6374 30.751 41.2105 35.943 39.8991C47.5379 37.0989 64.1152 34.3028 75.8359 31.9728C77.0008 31.6016 77.9981 30.7274 79.0793 30.1871C80.6217 29.3796 82.2906 28.8318 84.0168 28.5664",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3594 56.9554V56.7492L11.6525 54.7986C11.6525 54.7986 11.732 54.5099 11.8618 54.1553",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6438 33.9226C22.8596 35.1881 21.2287 36.6506 19.7829 38.2817C19.6488 38.4384 19.5063 38.6033 19.3597 38.7765C18.41 39.884 17.5944 41.0963 16.9292 42.3891C15.1273 46.0925 13.3129 50.3236 11.8672 54.1754C12.7601 52.9931 13.7316 51.8703 14.7753 50.8144C16.6988 48.707 19.4519 46.5048 21.2286 44.2985C25.3436 39.4776 28.8217 33.7494 34.1226 30.0791C30.854 31.0359 27.552 32.1576 24.6438 33.9226Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1211 30.0794C34.1389 30.0728 34.1571 30.0673 34.1756 30.0629L34.2595 29.9805L34.1211 30.0794Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2578 29.9815C36.3824 28.6659 38.8338 27.8989 41.2558 27.3256C54.7825 25.5235 92.8862 23.5233 106.069 23.5068",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2852 24.1407C53.0505 22.9629 55.879 21.9345 58.7582 21.0601C60.5769 20.9034 62.5464 20.6931 64.365 20.6024C70.3825 20.2106 76.5089 19.8889 82.5389 19.7734C89.0802 19.5714 95.7304 19.4848 102.272 19.4848C105.046 19.4683 108.017 19.6044 110.791 19.691C112.044 19.8023 113.481 20.3261 114.734 20.7096",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M106.199 21.8076L83.7256 22.3479L82.8834 22.3891L49.0205 24.216L41.3436 25.1274L35.146 26.0429C28.6801 26.8141 21.9335 28.4802 17.0559 32.9712C14.1603 35.7054 11.9184 39.2149 10.1836 42.7656C7.56035 47.8587 5.25142 53.4467 3.89791 58.9934C3.89791 58.9934 3.6842 59.146 3.39506 60.1151C2.59469 62.5235 2.43126 67.4228 2.17145 69.9095C1.85717 74.1985 1.42556 78.8132 1.07775 83.1062C0.388198 89.5436 0.104102 96.0169 0.227093 102.489",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M120.119 182.98C142.194 182.84 182.473 182.803 189.789 182.679C190.42 182.673 191.046 182.566 191.642 182.361C193.192 181.821 194.667 180.939 195.493 179.508C195.97 178.742 196.237 177.869 196.268 176.971C196.13 176.349 195.359 176.118 194.793 176.019C193.584 175.773 192.356 175.633 191.122 175.602C181.044 175.503 163.893 175.652 153.844 175.602C147.775 175.573 141.713 176.004 135.712 176.889C125.697 178.023 115.103 179.141 105.055 179.833C105.18 180.167 105.235 180.881 105.771 180.621C106.312 181.318 105.813 182.366 106.111 183.112L106.194 183.153C107.267 183.104 110.05 183.062 113.783 183.029",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M112.566 22.4707C113.011 22.9202 113.237 23.2996 113.744 23.3862L122.116 23.8811L121.249 22.5944",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M112.566 22.4706C113.32 22.2914 113.999 21.8848 114.507 21.3076L114.678 21.019C114.89 20.2201 114.975 19.3938 114.93 18.5693",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M122.941 3.04679H122.983L123.277 2.88184H123.319L124.794 3.54579",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M121.914 16.4914C121.922 16.4625 121.93 16.4377 121.939 16.4089C122.773 13.0602 124.298 7.61246 125.006 4.29267C124.981 4.02873 125.115 3.64933 124.797 3.52148C122.572 4.63083 122.199 7.66607 121.507 9.89301C120.983 11.9344 119.835 16.446 119.399 18.4007C119.404 18.5863 119.228 18.9657 119.525 18.941L120.191 18.7018C120.281 18.6686 120.365 18.6242 120.443 18.5698L121.323 17.9265C121.416 17.8602 121.485 17.7663 121.52 17.6584L121.914 16.4955V16.4914Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M112.564 22.4709L111.512 22.5946L112.341 25.0071C112.369 25.0918 112.422 25.1664 112.493 25.2215C112.563 25.2766 112.649 25.3096 112.74 25.3164C116.901 25.6504 121.858 26.1288 126.006 26.5124C126.026 26.5136 126.045 26.509 126.062 26.499C126.079 26.489 126.092 26.4742 126.1 26.4566C126.107 26.439 126.109 26.4195 126.106 26.4007C126.102 26.3818 126.092 26.3647 126.078 26.3515L122.348 22.8008L121.25 22.5946C119.406 22.0007 119.122 20.6068 119.608 18.916",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M119.44 18.941C118.053 19.2668 116.44 18.8751 115.082 18.5781",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M122.938 3.0476C122.985 2.97078 123.009 2.88248 123.008 2.79279C123.006 2.7031 122.979 2.61562 122.93 2.54035C122.779 2.27641 121.082 0.72168 120.826 0.72168L120.026 0.762919C119.887 0.774604 119.752 0.813463 119.629 0.877206C119.506 0.940949 119.397 1.02829 119.309 1.13408C118.119 2.44137 116.807 4.91575 115.894 6.48698C115.663 6.92666 115.478 7.38813 115.341 7.86439C115.156 8.42937 114.989 8.99848 114.834 9.57171C114.658 10.215 114.494 10.8584 114.335 11.51C113.802 13.5404 113.421 15.6066 113.195 17.6918C113.195 17.7465 113.205 17.8007 113.227 17.8511C113.249 17.9015 113.281 17.947 113.321 17.9846C113.528 18.1631 113.775 18.2915 114.042 18.3599C114.536 18.5661 115.077 18.64 115.61 18.5741C116.143 18.5082 116.649 18.3048 117.076 17.9846C117.625 17.6794 117.813 16.0711 118.002 15.535C118.928 12.3719 119.858 7.67468 121.166 4.82915C121.166 4.82915 121.392 4.43325 121.509 4.26417C121.832 3.79816 122.67 2.83727 122.938 3.0476Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M112.566 182.493C113.011 182.044 113.237 181.664 113.744 181.578L122.116 181.083L121.249 182.37",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M112.566 182.494C113.32 182.673 113.999 183.08 114.507 183.657L114.678 183.946C114.89 184.745 114.975 185.571 114.93 186.395",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M122.941 201.913H122.983L123.277 202.082H123.319L124.794 201.418",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M121.914 188.469C121.922 188.498 121.93 188.523 121.939 188.552C122.773 191.9 124.298 197.348 125.006 200.668C124.981 200.932 125.115 201.311 124.797 201.439C122.572 200.33 122.199 197.295 121.507 195.068C120.983 193.026 119.835 188.515 119.399 186.56C119.404 186.374 119.228 185.995 119.525 186.02L120.191 186.259C120.281 186.292 120.365 186.336 120.443 186.391L121.323 187.034C121.416 187.1 121.485 187.194 121.52 187.302L121.914 188.465V188.469Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M112.564 182.494L111.512 182.37L112.341 179.958C112.369 179.873 112.422 179.798 112.493 179.743C112.563 179.688 112.649 179.655 112.74 179.648C116.901 179.314 121.858 178.836 126.006 178.452C126.026 178.451 126.045 178.456 126.062 178.466C126.079 178.476 126.092 178.491 126.1 178.508C126.107 178.526 126.109 178.545 126.106 178.564C126.102 178.583 126.092 178.6 126.078 178.613L122.348 182.164L121.25 182.37C119.406 182.964 119.122 184.358 119.608 186.049",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M119.44 186.019C118.053 185.694 116.44 186.085 115.082 186.382",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M122.938 201.913C122.985 201.99 123.009 202.078 123.008 202.168C123.006 202.258 122.979 202.345 122.93 202.42C122.779 202.684 121.082 204.239 120.826 204.239L120.026 204.198C119.887 204.186 119.752 204.147 119.629 204.084C119.506 204.02 119.397 203.932 119.309 203.827C118.119 202.519 116.807 200.045 115.894 198.474C115.663 198.034 115.478 197.573 115.341 197.096C115.156 196.531 114.989 195.962 114.834 195.389C114.658 194.746 114.494 194.102 114.335 193.451C113.802 191.42 113.421 189.354 113.195 187.269C113.195 187.214 113.205 187.16 113.227 187.11C113.249 187.059 113.281 187.014 113.321 186.976C113.528 186.798 113.775 186.669 114.042 186.601C114.536 186.395 115.077 186.321 115.61 186.387C116.143 186.453 116.649 186.656 117.076 186.976C117.625 187.281 117.813 188.89 118.002 189.426C118.928 192.589 119.858 197.286 121.166 200.132C121.166 200.132 121.392 200.528 121.509 200.697C121.832 201.163 122.67 202.124 122.938 201.913Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M115.382 33.6834C115.382 33.6834 116.153 36.5083 111.975 36.2526C108.435 36.1162 104.911 35.7178 101.432 35.0608C101.432 35.0608 94.8069 33.7741 87.5281 31.8936C85.4756 35.7188 83.7285 39.6952 82.3026 43.7871C82.2916 43.8077 82.2851 43.8304 82.2836 43.8536C82.2821 43.8769 82.2856 43.9002 82.2939 43.922C82.3022 43.9438 82.3151 43.9636 82.3318 43.9802C82.3485 43.9967 82.3685 44.0096 82.3906 44.018L82.7091 44.0922C82.7091 44.0922 79.2981 53.5279 77.5632 70.0196C76.386 80.8014 75.8236 91.6397 75.8787 102.483",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M86.792 33.2393H85.0655C85.0655 33.2393 82.237 39.3056 81.0846 43.0832C81.0846 43.0832 78.2645 46.9556 77.7658 49.0423C77.7406 49.1533 77.728 49.2667 77.7281 49.3805L77.7029 54.2014L75.57 66.1897L76.0268 66.5197L75.306 71.5715C75.0823 71.7142 74.9197 71.9329 74.8493 72.186C74.8493 72.186 73.6508 86.0425 73.5167 90.2036L73.3281 95.3544C73.4049 95.579 73.5425 95.7786 73.7262 95.9318L73.7095 99.4371",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9844 102.48C71.0975 49.1122 83.4174 31.1895 83.4174 31.1895L84.0082 31.0781H84.268C105.187 32.0019 137.947 36.6578 137.947 36.6578",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2656 102.48V100.1L73.588 99.8651L73.8183 99.8115V102.48H73.2656Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2656 100.1L73.4457 99.7293L73.7346 99.4365L73.8811 99.6551L73.6215 99.7953L73.2656 100.1Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M105.436 83.5591C107.121 83.3941 113.419 83.1343 114.332 83.3488C115.032 83.7199 116.394 86.8253 116.713 87.4562C116.725 87.4853 116.733 87.5158 116.738 87.547C116.748 87.6239 116.737 87.702 116.707 87.7736C116.677 87.8452 116.628 87.9079 116.566 87.9552C116.327 88.1284 108.868 88.2192 107.456 87.9965C107.184 87.9965 105.583 84.6849 105.306 84.2602C105.228 84.136 105.185 83.9937 105.181 83.8478C105.178 83.8125 105.182 83.7771 105.193 83.7435C105.204 83.7099 105.222 83.6788 105.245 83.652C105.269 83.6251 105.297 83.6031 105.329 83.5872C105.361 83.5712 105.396 83.5617 105.432 83.5591H105.436Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3121 83.5921C91.3121 83.5921 107.206 82.058 113.79 82.0167C117.23 81.9714 120.75 81.9178 124.161 82.4333C125.557 84.1824 126.68 86.127 127.492 88.2027C127.492 88.2027 127.915 89.4234 127.953 89.576V89.5677C128.02 89.7987 127.643 89.6749 127.643 89.6749C125.804 88.9574 99.7139 89.6131 90.9727 89.4028C90.9727 89.4028 91.0732 85.4602 91.3121 83.5921ZM91.3121 83.5921C91.266 83.9303 91.2702 83.5921 91.2702 83.5921H91.3121Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M118.508 83.0195C119.86 83.0193 121.212 83.0896 122.556 83.2299C122.556 83.2299 122.787 83.2505 123.063 83.6464C123.51 84.2581 123.918 84.8958 124.287 85.5558C124.788 86.3763 125.185 87.2544 125.469 88.1704C125.49 88.2652 125.427 88.2528 125.427 88.2528C124.165 88.1827 122.766 88.1827 121.492 88.1333C121.429 88.1323 121.368 88.1186 121.311 88.093C121.254 88.0675 121.203 88.0306 121.161 87.9848C120.899 87.5694 120.674 87.1319 120.49 86.6775C119.946 85.5269 118.927 84.2608 118.257 83.1927C118.257 83.1927 118.11 82.9865 118.508 83.0278V83.0195Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M124.122 82.1856C123.644 70.2138 122.286 46.4762 121.465 34.459",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M103.798 35.499C103.685 39.623 100.315 71.526 101.267 74.8004C101.706 77.6237 103.157 80.1994 105.357 82.0627C105.868 82.0338 106.576 81.9679 107.087 81.8977C104.861 80.1008 103.353 77.5866 102.83 74.8004C101.878 71.625 104.908 39.6725 104.979 35.7093L103.798 35.5031V35.499Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2461 89.7414L112.013 89.7126L118.763 89.7002H120.62C121.6 93.8914 122.088 98.1796 122.074 102.48",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M124.183 82.4453L124.598 82.5154C124.598 82.5154 127.514 85.8517 128.566 89.8767L128.059 90.1613L127.988 89.9633C127.988 89.9633 123.278 89.3571 121.43 89.6623C121.43 89.6623 122.842 96.3101 122.842 102.48",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M121.895 92.2775L122.1 91.7744C122.1 91.7744 125.444 91.8363 126.114 91.9559L126.336 92.3765V92.6569C126.929 95.8981 127.208 99.1872 127.17 102.48",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M123.255 102.48L122.891 94.9206C122.891 94.8875 122.898 94.8547 122.912 94.8244C122.925 94.7941 122.945 94.7669 122.97 94.7445C122.995 94.722 123.024 94.7048 123.056 94.694C123.087 94.6831 123.121 94.6788 123.155 94.6814H125.866C125.866 94.6814 126.214 94.5618 126.251 95.3412C126.559 97.7084 126.702 100.093 126.679 102.48",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M129.055 102.479C129.055 55.9443 138.479 38.6113 138.479 38.6113C138.043 38.2608 138.445 37.7824 138.445 37.7824C138.739 37.0318 138.186 36.7761 138.186 36.7761C137.909 36.7926 137.926 36.4875 137.926 36.4875L138.493 34.875L140.11 35.1183C140.11 35.1183 141.59 35.4194 140.571 37.0648L140.148 38.2195C140.148 38.2195 130.527 53.6102 130.527 102.475",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M138.328 36.8916L140.574 37.0689",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 37.2637L140.432 37.4245",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M140.414 37.3964C140.414 37.3964 141.369 37.4541 141.642 34.9426C141.642 34.9426 141.663 34.5591 142.4 34.7117C142.4 34.7117 150.991 36.7324 168.679 37.0829L200.052 38.217",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M140.094 38.2412L150.528 39.6062L200.05 41.4785",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4204 177.68C86.4078 177.623 86.3282 177.569 86.3366 177.515C103.274 176.464 120.799 174.464 137.573 171.952C137.544 171.672 137.917 171.037 137.996 170.542C138.114 169.898 137.489 168.971 137.363 168.344",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0479 122.444V122.32C89.9506 122.169 89.8204 122.041 89.6666 121.945C89.2769 121.883 87.2277 121.537 86.8422 121.487C86.7015 121.439 86.5481 121.442 86.4091 121.495C86.2702 121.548 86.1549 121.647 86.0837 121.776C86.0466 122.024 86.0326 122.276 86.0418 122.527L86.7081 133.859L88.3717 145.093L91.0159 156.141C91.0592 156.334 91.1634 156.509 91.3134 156.64C91.7283 156.776 93.0524 156.896 93.505 156.974C93.6495 156.982 93.7937 156.954 93.924 156.892C93.9605 156.827 93.9887 156.757 94.0079 156.685C91.7199 145.509 90.6806 133.822 90.0437 122.448L90.0479 122.444Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0938 180.296C47.4584 181.4 49.8795 182.383 52.3474 183.24C53.8392 183.665 58.126 183.904 58.126 183.904L58.1679 183.863V183.727",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5938 179.878C43.249 180.637 46.0691 181.73 47.7495 182.41C49.2945 182.837 50.8749 183.128 52.4721 183.28",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M141.524 174.277C137.744 174.731 113.691 177.506 110.201 178.261C109.324 178.485 108.475 178.805 107.67 179.214L106.953 179.63C106.852 179.663 106.723 179.704 106.609 179.729",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M105.06 179.838C96.1092 180.556 92.0613 181.125 84.0156 176.395",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M199.473 174.279L203.99 174.292V174.279L204.116 174.234L204.199 174.156L204.241 174.073V167.928L204.199 167.805L204.116 167.681H203.99L202.008 167.677L199.519 167.722",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M333.687 185.256L333.615 185.182L333.574 185.058L333.527 173.065L333.318 172.443L204.24 172.232L204.282 184.6L204.156 184.811",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M141.831 174.279C155.081 174.068 185.918 174.254 199.474 174.279L199.516 167.722C187.515 167.808 175.363 168.109 163.378 168.802C159.087 169.107 154.67 169.433 150.392 169.837C146.591 170.246 141.944 170.918 138.164 171.582V171.829C139.118 172.852 140.263 173.684 141.537 174.279H141.831Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3242 170.667C36.2845 170.609 70.227 173.686 77.8201 174.028",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4258 159.712C25.1358 162.327 30.751 163.753 35.943 165.065C47.5379 167.865 64.1152 170.661 75.8359 172.991C77.0008 173.362 77.9981 174.237 79.0793 174.777C80.6217 175.584 82.2906 176.132 84.0168 176.397",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3594 148.008V148.214L11.6525 150.165C11.6525 150.165 11.732 150.453 11.8618 150.808",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6438 171.041C22.8596 169.775 21.2287 168.313 19.7829 166.682C19.6488 166.525 19.5063 166.36 19.3597 166.187C18.41 165.08 17.5944 163.867 16.9292 162.574C15.1273 158.871 13.3129 154.64 11.8672 150.788C12.7601 151.97 13.7316 153.093 14.7753 154.149C16.6988 156.256 19.4519 158.459 21.2286 160.665C25.3436 165.486 28.8217 171.214 34.1226 174.884C30.854 173.928 27.552 172.806 24.6438 171.041Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1211 174.885C34.1389 174.891 34.1571 174.897 34.1756 174.901L34.2595 174.984L34.1211 174.885Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2578 174.983C36.3824 176.299 38.8338 177.066 41.2558 177.639C54.7825 179.441 92.8862 181.442 106.069 181.458",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2852 180.823C53.0505 182.001 55.879 183.029 58.7582 183.904C60.5769 184.061 62.5464 184.271 64.365 184.362C70.3825 184.753 76.5089 185.075 82.5389 185.191C89.0802 185.393 95.7304 185.479 102.272 185.479C105.046 185.496 108.017 185.36 110.791 185.273C112.211 185.149 113.351 184.642 114.721 184.263",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M106.199 183.157L83.7256 182.617L82.8834 182.575L49.0205 180.748L41.3436 179.837L35.146 178.922C28.6801 178.15 21.9335 176.484 17.0559 171.993C14.1603 169.259 11.9184 165.75 10.1836 162.199C7.56035 157.106 5.25142 151.518 3.89791 145.971C3.89791 145.971 3.6842 145.818 3.39506 144.849C2.59469 142.441 2.43126 137.542 2.17145 135.055C1.85717 130.766 1.42556 126.151 1.07775 121.858C0.388198 115.421 0.104102 108.948 0.227093 102.476",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M115.382 171.28C115.382 171.28 116.153 168.455 111.975 168.71C108.435 168.847 104.911 169.245 101.432 169.902C101.432 169.902 94.8069 171.189 87.5281 173.069C85.4756 169.244 83.7285 165.268 82.3026 161.176C82.2916 161.155 82.2851 161.133 82.2836 161.109C82.2821 161.086 82.2856 161.063 82.2939 161.041C82.3022 161.019 82.3151 160.999 82.3318 160.983C82.3485 160.966 82.3685 160.953 82.3906 160.945L82.7091 160.871C82.7091 160.871 79.2981 151.435 77.5632 134.943C76.386 124.162 75.8236 113.323 75.8787 102.479",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M86.792 171.725H85.0655C85.0655 171.725 82.237 165.659 81.0846 161.881C81.0846 161.881 78.2645 158.009 77.7658 155.922C77.7406 155.811 77.728 155.698 77.7281 155.584L77.7029 150.763L75.57 138.775L76.0268 138.445L75.306 133.393C75.0823 133.25 74.9197 133.032 74.8493 132.779C74.8493 132.779 73.6508 118.922 73.5167 114.761L73.3281 109.61C73.4049 109.386 73.5425 109.186 73.7262 109.033L73.7095 105.527",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9844 102.484C71.0975 155.853 83.4174 173.775 83.4174 173.775L84.0082 173.887H84.268C105.187 172.963 137.947 168.307 137.947 168.307",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2656 102.484V104.864L73.588 105.099L73.8183 105.153V102.484H73.2656Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2656 104.864L73.4457 105.235L73.7346 105.528L73.8811 105.31L73.6215 105.169L73.2656 104.864Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M105.436 121.405C107.121 121.57 113.419 121.83 114.332 121.615C115.032 121.244 116.394 118.139 116.713 117.508C116.725 117.479 116.733 117.448 116.738 117.417C116.748 117.34 116.737 117.262 116.707 117.191C116.677 117.119 116.628 117.056 116.566 117.009C116.327 116.836 108.868 116.745 107.456 116.968C107.184 116.968 105.583 120.279 105.306 120.704C105.228 120.828 105.185 120.971 105.181 121.116C105.178 121.152 105.182 121.187 105.193 121.221C105.204 121.254 105.222 121.285 105.245 121.312C105.269 121.339 105.297 121.361 105.329 121.377C105.361 121.393 105.396 121.403 105.432 121.405H105.436Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3121 121.372C91.3121 121.372 107.206 122.906 113.79 122.947C117.23 122.993 120.75 123.046 124.161 122.531C125.557 120.781 126.68 118.837 127.492 116.761C127.492 116.761 127.915 115.541 127.953 115.388V115.396C128.02 115.165 127.643 115.289 127.643 115.289C125.804 116.007 99.7139 115.351 90.9727 115.561C90.9727 115.561 91.0732 119.504 91.3121 121.372ZM91.3121 121.372C91.266 121.034 91.2702 121.372 91.2702 121.372H91.3121Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M118.508 121.946C119.86 121.946 121.212 121.876 122.556 121.735C122.556 121.735 122.787 121.715 123.063 121.319C123.51 120.707 123.918 120.07 124.287 119.41C124.788 118.589 125.185 117.711 125.469 116.795C125.49 116.7 125.427 116.712 125.427 116.712C124.165 116.783 122.766 116.783 121.492 116.832C121.429 116.833 121.368 116.847 121.311 116.872C121.254 116.898 121.203 116.935 121.161 116.98C120.899 117.396 120.674 117.833 120.49 118.288C119.946 119.438 118.927 120.704 118.257 121.773C118.257 121.773 118.11 121.979 118.508 121.938V121.946Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M124.122 122.778C123.644 134.75 122.286 158.488 121.465 170.505",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M103.798 169.465C103.685 165.341 100.315 133.438 101.267 130.164C101.706 127.34 103.157 124.765 105.357 122.901C105.868 122.93 106.576 122.996 107.087 123.066C104.861 124.863 103.353 127.377 102.83 130.164C101.878 133.339 104.908 165.292 104.979 169.255L103.798 169.461V169.465Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2461 115.223L112.013 115.252L118.763 115.265H120.62C121.6 111.073 122.088 106.785 122.074 102.484",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M124.183 122.519L124.598 122.448C124.598 122.448 127.514 119.112 128.566 115.087L128.059 114.803L127.988 115.001C127.988 115.001 123.278 115.607 121.43 115.302C121.43 115.302 122.842 108.654 122.842 102.484",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M121.895 112.691L122.1 113.194C122.1 113.194 125.444 113.132 126.114 113.013L126.336 112.592V112.312C126.929 109.07 127.208 105.781 127.17 102.488",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M123.255 102.484L122.891 110.044C122.891 110.077 122.898 110.109 122.912 110.14C122.925 110.17 122.945 110.197 122.97 110.22C122.995 110.242 123.024 110.259 123.056 110.27C123.087 110.281 123.121 110.285 123.155 110.283H125.866C125.866 110.283 126.214 110.402 126.251 109.623C126.559 107.256 126.702 104.871 126.679 102.484",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M129.055 102.484C129.055 149.019 138.479 166.352 138.479 166.352C138.043 166.703 138.445 167.181 138.445 167.181C138.739 167.932 138.186 168.187 138.186 168.187C137.909 168.171 137.926 168.476 137.926 168.476L138.492 170.089L140.109 169.845C140.109 169.845 141.588 169.544 140.57 167.899L140.147 166.744C140.147 166.744 130.526 151.353 130.526 102.489",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M138.328 168.072L140.574 167.895",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 167.701L140.432 167.54",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M140.414 167.57C140.414 167.57 141.369 167.512 141.642 170.023C141.642 170.023 141.663 170.407 142.4 170.254C142.4 170.254 150.991 168.234 168.679 167.883L200.052 166.749",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M140.094 166.723L150.528 165.358L200.05 163.485",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M200.656 161.716V163.534",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M153.723 122.543L153.932 122.749L153.974 122.79C156.719 125.809 159.011 127.636 162.724 129.018C162.992 129.117 163.587 129.265 163.587 129.265C164.86 129.691 166.174 129.985 167.509 130.143C173.229 130.444 184.887 130.84 190.531 131.047",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M154.562 122.168C155.82 123.496 157.152 125.005 158.703 126.02C158.77 126.065 158.824 126.11 158.824 126.11C161.873 128.113 165.419 129.258 169.08 129.422C169.176 129.422 169.298 129.434 169.344 129.439C175.604 129.661 182.414 129.88 188.678 130.14",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M156.012 123.685C156.57 123.405 157.167 123.21 157.784 123.103C158.568 122.955 160.529 122.856 160.529 122.856C164.883 122.728 169.425 123.483 173.683 124.353C175.606 124.77 177.823 125.429 179.755 125.763C181.083 125.887 182.449 126.135 183.79 126.172C183.866 126.172 183.928 126.176 183.928 126.176C184.557 126.213 185.24 126.225 185.869 126.217",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M155.194 124.078C154.146 124.647 153.283 125.496 152.705 126.528C151.846 127.827 151.159 133.085 150.807 134.623L150.216 139.559L149.961 142.05L149.793 144.5C149.663 147.28 149.617 148.925 150.409 154.055V154.039C151.113 156.303 151.993 158.072 154.247 158.996",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M185.431 124.911C184.254 124.87 183.06 124.68 181.89 124.536C177.105 123.567 171.511 122.008 166.667 121.422C163.383 121.112 160.075 121.143 156.798 121.517C156.727 121.525 155.818 121.748 155.449 121.876C154.734 122.102 154.042 122.395 153.383 122.75C152.832 123.111 152.311 123.513 151.824 123.954C150.005 125.649 149.628 128.553 149.209 130.883L148.618 134.038L148.111 137.192C147.986 138.244 147.663 140.949 147.567 141.964L147.399 145.16C147.378 149.115 147.894 153.284 149.465 156.946C150.059 158.326 151.095 159.478 152.415 160.225C152.415 160.225 152.713 160.394 153.044 160.571C153.13 160.617 153.22 160.657 153.312 160.691C153.936 160.918 154.594 161.181 155.26 161.355C158.726 162.188 164.064 162.373 168.188 161.924C172.563 161.544 177.729 160.344 182.159 160.126L182.98 160.101H184.564",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M185.137 158.916C182.986 158.685 180.818 158.663 178.663 158.85C175.734 159.122 172.553 159.872 169.565 160.124L168.702 160.21C165.693 160.509 162.664 160.555 159.647 160.347C158.138 160.161 156.563 160.074 155.18 159.435",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M197.665 125.945C197.586 126.424 197.364 128.457 197.284 128.976C197.167 129.525 197.112 129.727 196.886 129.95C196.672 130.152 196.397 130.283 196.102 130.321C194.002 130.547 191.892 130.667 189.779 130.68C189.025 130.642 188.493 129.962 188.048 129.517C186.797 128.222 185.898 126.637 185.434 124.91",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M196.388 160.261C196.309 159.782 196.086 157.749 196.007 157.23C195.889 156.681 195.835 156.479 195.609 156.256C195.394 156.053 195.12 155.923 194.825 155.885C192.725 155.659 190.614 155.539 188.502 155.526C187.747 155.563 187.215 156.244 186.771 156.689C185.52 157.984 184.621 159.568 184.156 161.296",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M197.068 130.961L196.817 143.168L196.227 155.329",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M196.228 155.328C195.998 155.216 190.11 154.738 189.691 154.705",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M191.001 130.676L190.535 131.051",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M189.648 155.609L190.113 143.295L190.536 131.051",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M161.82 154.373L162.239 142.838L162.281 141.675L162.746 129.019",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M180.668 154.042L181.091 142.379L181.551 130.717",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M189.7 154.372C183.213 154.24 172.046 153.522 165.513 153.638C164.166 153.796 162.834 154.055 161.528 154.413C160.882 154.664 160.183 154.842 159.546 155.118C159.135 155.386 158.666 155.625 158.238 155.864C156.365 157.168 154.337 158.718 152.883 160.471",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M153.676 160.805C157.401 157.428 158.172 155.943 163.377 154.83C164.597 154.572 165.838 154.419 167.085 154.372C173.756 154.587 181.111 154.921 187.79 155.119L188.59 155.16L189.655 155.201",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M190.539 131.571L191.788 131.505C191.788 131.505 197.017 131.122 197.068 130.965C197.068 130.965 197.914 130.33 198.065 126.206",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M207.087 130.961C207.128 127.286 206.672 127.125 206.672 127.125C203.726 124.556 193.111 123.166 193.111 123.166L188.921 122.882C184.856 123.084 185.397 124.882 185.397 124.882C185.397 124.882 185.854 122.882 192.902 124.597L197.13 125.698C197.13 125.698 201.526 127.084 201.279 131.006L201.237 143.786C201.237 143.786 201.086 157.42 199.246 158.554L196.384 160.27C196.384 160.27 187.718 163.495 184.152 161.412",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M190.789 123.001L196.262 124.267C196.262 124.267 200.037 125.207 201.362 127.125C201.362 127.125 202.317 128.065 202.317 131.043",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M201.16 126.919C201.16 126.919 202.157 126.469 206.675 127.121",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M184.168 161.407C184.168 161.407 183.975 162.838 186.447 163.028C186.447 163.028 190.428 163.758 197.648 161.003L199.572 159.679C199.967 159.416 200.305 159.077 200.564 158.682C200.824 158.287 200.999 157.845 201.08 157.382C201.351 156.244 201.535 155.087 201.629 153.922",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M196.16 155.333C196.16 155.333 196.742 155.457 196.742 156.682L196.734 160.055",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M199.992 159.354C199.992 159.354 203.252 159.886 205.628 159.452",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M187.219 163.131C191.219 163.362 195.232 163.019 199.132 162.113L203.442 160.987C203.442 160.987 206.031 160.261 206.031 158.224L206.358 154.335",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M209.738 146.355C209.512 151.642 208.732 152.739 208.732 152.739C208.569 153.174 208.28 153.552 207.901 153.827C207.522 154.102 207.07 154.261 206.599 154.286L202.438 154.265C202.268 154.253 202.101 154.208 201.949 154.131C201.797 154.055 201.662 153.949 201.552 153.82C201.442 153.691 201.36 153.542 201.31 153.381C201.26 153.22 201.243 153.051 201.261 152.883L201.977 142.697L201.944 141.423V132.111C201.944 131.784 202.076 131.471 202.311 131.239C202.546 131.008 202.865 130.878 203.197 130.878L207.366 130.96C207.815 130.985 208.248 131.135 208.612 131.394C208.977 131.653 209.259 132.009 209.424 132.42C209.424 132.42 210.367 133.748 210.01 140.565C210.01 140.565 209.767 145.605 209.734 146.355H209.738Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M201.27 152.763C201.27 152.763 202.673 152.673 203.482 149.188C203.878 147.586 204.107 145.949 204.165 144.301C204.19 143.847 204.366 140.585 204.35 140.21C204.266 137.855 203.96 135.682 203.96 135.682C203.361 132.057 201.944 132.222 201.944 132.222",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M347.779 29.6098C347.548 29.548 346.689 29.4614 346.383 29.2387C346.237 29.1281 346.119 28.9864 346.037 28.8242C345.955 28.6621 345.911 28.4837 345.91 28.3025C345.859 27.9107 345.771 26.9169 345.767 26.7725C345.741 26.0128 345.808 25.2528 345.964 24.5085C346.043 24.1866 346.17 23.8781 346.341 23.593C346.427 23.4235 346.559 23.2807 346.723 23.1806C347.917 22.993 349.126 22.9115 350.335 22.9372L472.089 24.3848C471.134 25.4487 469.906 26.6158 468.841 27.5808C468.217 28.1541 467.408 29.0201 466.65 29.4077C465.091 30.0923 463.268 30.1995 461.588 30.3604L453.743 30.4429L348.022 29.6387L347.774 29.6139L347.779 29.6098Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M477.196 21.3079C398.532 19.4645 288.177 19.5263 207.843 20.1573C206.573 20.1655 202.559 20.1449 201.683 20.1325C185.806 19.9016 138.823 21.5677 119.551 21.1058",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M347.745 29.6348L333.527 29.5234",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M471.971 38.2041H209.934V41.4827H471.971V38.2041Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M473.907 32.3893L473.781 32.1377L473.655 32.0965L471.25 32.0181L467.416 31.8903L463.531 31.8078L459.655 31.7253L455.775 31.6841L448.06 31.6016L440.764 31.515L333.531 30.7686",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M492.168 102.068V102.481L492.21 102.567L492.336 102.604H493.643L493.727 102.646L493.811 102.691V102.901",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M499.379 102.063V102.604L499.425 102.69L499.526 102.892",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M487.738 47.1611L488.199 49.9036L488.832 53.7595L489.339 57.4546L489.846 61.2733L490.097 63.8013L490.353 66.3747L490.818 71.5214L491.028 74.3875L491.237 77.2908L491.535 82.8087L491.702 87.4152L491.786 90.6525L491.87 93.931L491.954 98.5787V101.857L491.996 101.981L492.038 102.068H500.18",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M493.309 42.6816L493.346 42.7641",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M492.16 36.5137L493.345 42.7656",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M497.734 102.067C497.788 100.541 497.172 85.2826 497.859 84.3053C497.884 82.499 497.834 80.6308 497.776 78.8286C497.336 70.0405 496.56 60.9471 495.328 52.2291C495.01 50.0063 494.633 47.6102 494.147 45.4245C493.916 44.5667 493.811 43.5316 493.346 42.7687L493.304 42.6862C493.228 42.6288 493.141 42.5868 493.049 42.5625C492.311 43.2182 491.532 44.0801 490.815 44.7606C490.321 45.3091 489.541 45.9194 489.508 46.7112",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M487.484 45.8332L487.233 44.3816V44.2579L487.145 42.5918",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M487.484 45.834L487.74 47.1619",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M494.695 31.1016C496.543 35.1183 497.532 39.9928 498.119 44.4467C498.178 44.8839 498.211 45.2839 498.24 45.6427C499.393 60.4559 500.331 88.0576 500.181 102.063",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M477.457 22.4746L477.62 22.5117C481.674 22.7867 485.689 23.4637 489.605 24.5325L490.493 24.7387L492.086 24.0458",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M488.795 22.8009C485.476 21.8523 480.465 21.4152 476.987 21.0977C476.84 21.0977 476.739 21.2049 476.609 21.2626",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M484.802 23.0783L489.261 22.7978C489.261 22.7978 489.525 22.7566 489.642 23.2185L489.906 24.4886L484.84 23.1855C484.84 23.1855 484.744 23.1442 484.806 23.0783H484.802Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M489.598 23.0938C489.598 23.0938 490.825 23.4814 490.901 23.5103C490.901 23.5103 491.84 23.7577 492.083 24.0505L492.305 24.265L492.284 24.3309L490.566 25.0114",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M477.229 21.3125L477.317 21.4568L477.493 22.8384L476.567 25.622L473.566 32.0967",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M490.488 24.7393L490.564 25.0073L490.69 25.8486",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M490.155 25.5435L484.603 34.1337C484.603 34.1337 483.526 35.639 483.878 38.2082L484.661 41.9528H474.579L473.892 37.7834L473.066 37.6309C473.477 32.979 473.951 32.2656 473.951 32.2656L477.01 25.7786L477.911 22.9619L480.048 23.1722L483.501 23.6547L486.053 24.195L489.484 25.2548C489.484 25.2548 490.683 25.3909 491.425 27.0488C492.024 28.3135 492.487 29.6362 492.808 30.9954C492.835 31.122 492.814 31.2542 492.749 31.3666L491.031 33.3667",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M473.068 37.6309C473.068 37.6309 473.047 37.9608 472.871 37.9402V38.5381",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M471.992 38.542H472.98C472.98 38.542 473.014 42.0721 472.738 42.6123",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M488.771 29.6514L485.444 34.9465C485.557 34.4104 483.914 33.8083 482.691 33.4413C481.995 33.2332 481.287 33.0679 480.57 32.9464L478.752 32.6289L474.004 32.1835",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M489.333 28.8585C490.515 30.4627 490.997 33.2835 490.997 33.2835C491.009 33.6959 490.322 33.7495 490.322 33.7495C489.999 32.203 489.423 30.7183 488.617 29.3534L488.508 28.2646C488.508 28.2646 488.797 28.1079 489.237 28.7306L489.333 28.8585Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M491.052 26.3691L489.359 28.8394",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M490.319 33.75L490.377 33.9644L487.222 38.4142L487 39.7586L487.256 39.1895L487.645 38.6864L490.692 34.3892L492.879 31.8323C492.879 31.8323 493.055 31.6921 493.114 32.0715L493.323 32.8798L494.258 32.6406C494.449 32.601 494.617 32.4887 494.724 32.328C494.832 32.1674 494.87 31.9714 494.832 31.7829C494.449 29.4826 493.76 27.242 492.783 25.1185L492.418 24.3762L492.309 24.2607",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M490.348 34.8917C490.348 34.8917 490.545 34.8092 490.591 35.0443L491.035 36.7598C491.035 36.7598 491.089 37.0568 491.177 37.0114L491.668 36.401C491.668 36.401 491.722 36.3103 491.647 36.0711L491.182 34.104C491.182 34.104 491.169 33.9927 491.014 34.0256",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M494.502 32.5088L494.367 33.4491C494.263 33.7129 494.112 33.9571 493.923 34.1707L489.1 40.5588C489.1 40.5588 488.58 40.9712 488.958 43.8579",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M487.848 38.418L489.545 46.8144L491.368 61.7307L492.947 75.0264L493.744 102.063",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M486.066 33.9521L486.736 35.0326",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M487.137 35.8457L487.694 37.6685V37.7386",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M487 39.7578L487.143 42.591",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M487.145 42.5918L472.047 42.6253",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M347.779 175.355C347.548 175.416 346.689 175.503 346.383 175.726C346.237 175.836 346.119 175.978 346.037 176.14C345.955 176.302 345.911 176.481 345.91 176.662C345.859 177.054 345.771 178.047 345.767 178.192C345.741 178.952 345.808 179.712 345.964 180.456C346.043 180.778 346.17 181.086 346.341 181.371C346.427 181.541 346.559 181.684 346.723 181.784C347.917 181.971 349.126 182.053 350.335 182.027L472.089 180.58C471.134 179.516 469.906 178.349 468.841 177.384C468.217 176.81 467.408 175.944 466.65 175.557C465.091 174.872 463.268 174.765 461.588 174.604L453.743 174.521L348.022 175.326L347.774 175.35L347.779 175.355Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M477.193 183.656C398.529 185.5 288.174 185.438 207.839 184.807C206.57 184.799 202.555 184.819 201.679 184.832C185.802 185.063 138.819 183.396 119.547 183.858",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M347.745 175.329L333.527 175.44",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M471.971 163.481H209.934V166.76H471.971V163.481Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M473.907 172.575L473.781 172.827L473.655 172.868L471.25 172.946L467.416 173.074L463.531 173.157L459.655 173.239L455.775 173.28L448.06 173.363L440.764 173.449L333.531 174.196",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M487.738 157.803L488.199 155.061L488.832 151.205L489.339 147.51L489.846 143.691L490.097 141.163L490.353 138.589L490.818 133.443L491.028 130.577L491.237 127.673L491.535 122.155L491.702 117.549L491.786 114.312L491.87 111.033L491.954 106.385V103.107L491.996 102.983L492.038 102.896L492.08 102.901H500.18",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M493.309 162.282L493.346 162.199",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M492.16 168.451L493.345 162.199",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M497.734 102.9C497.788 104.426 497.172 119.685 497.859 120.662C497.884 122.469 497.834 124.337 497.776 126.139C497.336 134.927 496.56 144.02 495.328 152.738C495.01 154.961 494.633 157.357 494.147 159.543C493.916 160.401 493.811 161.436 493.346 162.199L493.304 162.281C493.228 162.339 493.141 162.381 493.049 162.405C492.311 161.749 491.532 160.887 490.815 160.207C490.321 159.659 489.541 159.048 489.508 158.256",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M487.484 159.132L487.233 160.583V160.707L487.145 162.373",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M487.484 159.131L487.74 157.803",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M494.695 173.861C496.543 169.845 497.532 164.97 498.119 160.516C498.178 160.079 498.211 159.679 498.24 159.32C499.393 144.507 500.331 116.905 500.181 102.9",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M477.457 182.495L477.62 182.457C481.674 182.182 485.689 181.505 489.605 180.437L490.493 180.23L492.086 180.923",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M488.795 182.164C485.476 183.113 480.465 183.55 476.987 183.867C476.84 183.867 476.739 183.76 476.609 183.702",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M484.802 181.888L489.261 182.168C489.261 182.168 489.525 182.21 489.642 181.748L489.906 180.478L484.84 181.781C484.84 181.781 484.744 181.822 484.806 181.888H484.802Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M489.598 181.87C489.598 181.87 490.825 181.482 490.901 181.453C490.901 181.453 491.84 181.206 492.083 180.913L492.305 180.699L492.284 180.633L490.566 179.952",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M477.229 183.651L477.317 183.507L477.493 182.125L476.567 179.342L473.566 172.867",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M490.488 180.225L490.564 179.957L490.69 179.115",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M490.155 179.421L484.603 170.831C484.603 170.831 483.526 169.326 483.878 166.756L484.661 163.012H474.579L473.892 167.181L473.066 167.334C473.477 171.985 473.951 172.699 473.951 172.699L477.01 179.186L477.911 182.003L480.048 181.792L483.501 181.31L486.053 180.77L489.484 179.71C489.484 179.71 490.683 179.574 491.425 177.916C492.024 176.651 492.487 175.328 492.808 173.969C492.835 173.842 492.814 173.71 492.749 173.598L491.031 171.598",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M473.068 167.333C473.068 167.333 473.047 167.003 472.871 167.024V166.426",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M471.992 166.422H472.98C472.98 166.422 473.014 162.892 472.738 162.352",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M488.771 175.314L485.444 170.019C485.557 170.555 483.914 171.157 482.691 171.524C481.995 171.732 481.287 171.897 480.57 172.019L478.752 172.336L474.004 172.782",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M489.333 176.106C490.515 174.502 490.997 171.681 490.997 171.681C491.009 171.268 490.322 171.215 490.322 171.215C489.999 172.761 489.423 174.246 488.617 175.611L488.508 176.7C488.508 176.7 488.797 176.856 489.237 176.234L489.333 176.106Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M491.052 178.596L489.359 176.126",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M490.319 171.214L490.377 170.999L487.222 166.549L487 165.205L487.256 165.774L487.645 166.277L490.692 170.574L492.879 173.131C492.879 173.131 493.055 173.272 493.114 172.892L493.323 172.084L494.258 172.323C494.449 172.363 494.617 172.475 494.724 172.636C494.832 172.796 494.87 172.992 494.832 173.181C494.449 175.481 493.76 177.722 492.783 179.845L492.418 180.587L492.309 180.703",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M490.348 170.072C490.348 170.072 490.545 170.154 490.591 169.919L491.035 168.204C491.035 168.204 491.089 167.907 491.177 167.952L491.668 168.562C491.668 168.562 491.722 168.653 491.647 168.892L491.182 170.859C491.182 170.859 491.169 170.971 491.014 170.938",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M494.502 172.456L494.367 171.515C494.263 171.251 494.112 171.007 493.923 170.794L489.1 164.406C489.1 164.406 488.58 163.993 488.958 161.106",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M487.848 166.546L489.545 158.149L491.368 143.233L492.947 129.937L493.744 102.9",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M486.066 171.013L486.736 169.933",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M487.137 169.119L487.694 167.297V167.227",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M487 165.206L487.143 162.373",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M487.145 162.372L472.047 162.339",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M52.348 183.24C53.8398 183.665 58.1266 183.904 58.1266 183.904L58.1685 183.862L58.7593 183.904C60.578 184.06 62.5475 184.271 64.3661 184.361C70.3836 184.753 76.51 185.075 82.5401 185.19C89.0813 185.392 95.7315 185.479 102.273 185.479C105.047 185.496 108.018 185.359 110.792 185.273C111.886 185.178 113.729 184.58 114.723 184.263L114.924 186.39H114.928C114.625 186.426 114.327 186.495 114.04 186.597C113.773 186.664 113.526 186.793 113.319 186.972C113.278 187.01 113.246 187.055 113.225 187.105C113.203 187.156 113.192 187.21 113.193 187.265C113.417 189.35 113.798 191.417 114.333 193.447C114.492 194.094 114.656 194.742 114.832 195.385C114.991 195.958 115.154 196.527 115.339 197.092C115.475 197.568 115.661 198.03 115.892 198.47C116.805 200.045 118.117 202.519 119.307 203.822C119.395 203.928 119.504 204.016 119.627 204.079C119.75 204.143 119.885 204.182 120.023 204.194L120.824 204.235C121.079 204.235 122.777 202.68 122.927 202.416C122.977 202.341 123.004 202.253 123.006 202.164C123.007 202.074 122.983 201.986 122.936 201.909H122.978L123.275 202.074H123.317L124.771 201.418C124.779 201.422 124.786 201.426 124.792 201.431C125.111 201.307 124.977 200.923 125.002 200.659C124.298 197.335 122.768 191.892 121.934 188.543C121.926 188.514 121.918 188.49 121.909 188.461L121.515 187.298C121.479 187.191 121.41 187.097 121.318 187.03L120.438 186.386C120.363 186.329 120.278 186.284 120.187 186.254L119.609 186.044C119.413 185.444 119.359 184.808 119.454 184.184H119.919L154.817 184.11C173.275 184.465 211.392 184.827 211.392 184.827C243.721 185.071 280.664 185.223 318.327 185.195L333.677 185.248C333.677 185.248 432.832 184.654 474.221 183.718C475.109 183.698 476.597 183.693 476.597 183.693C476.731 183.751 476.828 183.858 476.974 183.858C480.452 183.541 485.464 183.108 488.783 182.155H489.248C489.248 182.155 489.457 182.188 489.587 181.866C489.587 181.866 490.815 181.479 490.891 181.45C490.891 181.45 491.829 181.203 492.072 180.91L492.294 180.695L492.403 180.58L492.768 179.837C493.653 177.909 494.303 175.883 494.704 173.804C496.539 169.796 497.524 164.946 498.107 160.504C498.165 160.067 498.199 159.667 498.228 159.308C499.364 144.743 500.29 117.801 500.177 103.594V100.88C500.269 86.5575 499.347 60.0446 498.228 45.6355C498.199 45.2767 498.165 44.8766 498.107 44.4395C497.524 39.998 496.539 35.1482 494.704 31.1397C494.303 29.0604 493.653 27.0351 492.768 25.1064L492.403 24.364L492.294 24.2486L492.072 24.0341C491.829 23.7413 490.891 23.4939 490.891 23.4939C490.811 23.465 489.587 23.0815 489.587 23.0774C489.457 22.7557 489.248 22.7846 489.248 22.7846H488.783C485.464 21.8361 480.452 21.403 476.974 21.0855C476.828 21.0855 476.727 21.1927 476.597 21.2505C476.597 21.2505 475.109 21.2422 474.221 21.2257C432.832 20.2896 333.677 19.6957 333.677 19.6957L318.327 19.7493C280.664 19.7246 243.721 19.873 211.392 20.1164C211.392 20.1164 173.271 20.4751 154.817 20.8339L119.919 20.7597H119.454C119.36 20.1376 119.413 19.5026 119.609 18.9039L120.187 18.6895C120.276 18.6563 120.361 18.6119 120.438 18.5575L121.318 17.9142C121.411 17.8479 121.481 17.7539 121.515 17.6461L121.909 16.4831C121.918 16.4543 121.926 16.4295 121.934 16.4007C122.768 13.052 124.294 7.60425 125.002 4.28446C124.977 4.02053 125.111 3.64112 124.792 3.51328C124.784 3.51484 124.777 3.51923 124.771 3.52565L123.317 2.86994H123.275L122.978 3.0349H122.936C122.983 2.95808 123.007 2.86979 123.006 2.78009C123.004 2.6904 122.977 2.60292 122.927 2.52765C122.777 2.26372 121.079 0.708984 120.824 0.708984L120.023 0.750224C119.885 0.761909 119.75 0.800767 119.627 0.864511C119.504 0.928254 119.395 1.01559 119.307 1.12138C118.117 2.42868 116.805 4.90306 115.892 6.47429C115.661 6.91396 115.475 7.37543 115.339 7.85169C115.154 8.41667 114.987 8.98578 114.832 9.55901C114.656 10.2023 114.492 10.8457 114.333 11.4973C113.8 13.5277 113.419 15.5939 113.193 17.6791C113.192 17.7338 113.203 17.788 113.225 17.8384C113.246 17.8888 113.278 17.9343 113.319 17.9719C113.526 18.1504 113.773 18.2789 114.04 18.3472C114.326 18.4494 114.625 18.5172 114.928 18.5493H114.924L114.735 20.6937C113.742 20.3803 111.886 19.7699 110.792 19.6751C108.018 19.5885 105.047 19.4524 102.273 19.4689C95.7315 19.4689 89.0771 19.5596 82.5401 19.7576C76.5058 19.873 70.3836 20.1947 64.3661 20.5865C62.5475 20.6731 60.578 20.8875 58.7593 21.0443L58.1685 21.0855L58.1266 21.0443C58.1266 21.0443 53.8398 21.2834 52.348 21.7082M52.4737 21.667C50.8771 21.8233 49.297 22.1144 47.7511 22.5371C46.0707 23.2176 43.2505 24.3104 41.5953 25.0692L41.3397 25.1105L35.1421 26.026C28.6762 26.7972 21.9296 28.4633 17.052 32.9543C14.1564 35.6885 11.9145 39.1979 10.1797 42.7487C7.55644 47.8418 5.24752 53.4297 3.89401 58.9765C3.89401 58.9765 3.68029 59.1291 3.39115 60.0982C2.59078 62.5066 2.42735 67.4059 2.16755 69.8926C1.85327 74.1815 1.42165 78.7962 1.07384 83.0893C0.384292 89.5267 0.100197 96 0.223187 102.472C0.10029 108.944 0.384385 115.417 1.07384 121.855C1.42165 126.148 1.85327 130.762 2.16755 135.051C2.42735 137.538 2.59078 142.437 3.39115 144.846C3.68448 145.815 3.89401 145.967 3.89401 145.967C5.24752 151.514 7.55644 157.102 10.1797 162.195C11.9145 165.746 14.1564 169.255 17.052 171.99C21.9296 176.485 28.6762 178.147 35.1421 178.918L41.3397 179.833L41.5953 179.875C43.2505 180.633 46.0707 181.726 47.7511 182.407C49.2961 182.833 50.8765 183.125 52.4737 183.277",
    stroke: "#26231E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M200.465 20.3926V38.2164",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M138.113 33.1357V21.0195",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M425.773 61.0127C425.773 61.0127 427.768 61.9138 427.768 67.7731V96.1872C427.768 96.1872 427.788 99.7116 425.966 101.878",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M457.637 60.3613H426.779C426.225 60.3613 425.773 61.121 425.773 62.0579V142.235C425.773 143.171 426.223 143.931 426.779 143.931H457.637C458.192 143.931 458.643 143.171 458.643 142.235V62.0579C458.642 61.121 458.192 60.3613 457.637 60.3613Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M458.64 101.913C458.64 101.913 456.234 101.003 456.234 95.0876V66.4009C456.234 66.4009 456.203 62.8424 458.413 60.6562",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M458.642 60.3613C458.642 60.3613 457.932 62.0851 453.333 62.0851H431.029C431.029 62.0851 428.263 62.1062 426.562 60.5246",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M441.524 81.7988C434.833 84.4617 426.328 101.284 426.328 101.284",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M457.201 100.422C457.201 100.422 449.581 84.3437 443.582 81.7988",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M457.44 61.373C457.44 61.373 456.633 63.0944 455.27 65.6397C452.588 70.6495 447.636 78.9283 443.453 80.7247",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M427.039 61.2051C427.039 61.2051 435.146 78.0568 441.524 80.7259",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M442.411 82.3877C442.641 82.3877 442.867 82.3204 443.058 82.1944C443.25 82.0685 443.399 81.8894 443.487 81.6799C443.575 81.4704 443.599 81.2399 443.554 81.0175C443.509 80.7951 443.398 80.5909 443.235 80.4305C443.072 80.2702 442.864 80.161 442.638 80.1168C442.412 80.0725 442.178 80.0952 441.965 80.182C441.752 80.2688 441.57 80.4157 441.442 80.6042C441.314 80.7928 441.246 81.0144 441.246 81.2412C441.246 81.5452 441.369 81.8368 441.587 82.0519C441.806 82.2669 442.102 82.3877 442.411 82.3877Z",
    fill: "#ECECEC",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M425.778 102.146C425.778 102.146 426.505 100.422 431.216 100.422H454.069C454.069 100.422 456.903 100.401 458.645 101.982",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M425.98 102.799C425.98 102.799 427.975 103.7 427.975 109.559V137.973C427.975 137.973 427.995 141.498 426.173 143.664",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M458.847 143.698C458.847 143.698 456.441 142.789 456.441 136.873V108.186C456.441 108.186 456.41 104.628 458.62 102.441",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M458.845 102.146C458.845 102.146 458.135 103.869 453.537 103.869H431.232C431.232 103.869 428.466 103.89 426.766 102.309",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M441.727 123.585C435.036 126.248 426.531 143.07 426.531 143.07",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M457.404 142.208C457.404 142.208 449.784 126.13 443.785 123.585",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M457.643 103.158C457.643 103.158 456.836 104.88 455.473 107.425C452.791 112.435 447.839 120.714 443.656 122.51",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M427.242 102.99C427.242 102.99 435.349 119.842 441.727 122.511",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M442.614 124.174C442.845 124.174 443.07 124.107 443.261 123.981C443.453 123.855 443.602 123.676 443.69 123.466C443.779 123.257 443.802 123.026 443.757 122.804C443.712 122.581 443.601 122.377 443.438 122.217C443.275 122.056 443.067 121.947 442.841 121.903C442.615 121.859 442.381 121.881 442.168 121.968C441.955 122.055 441.774 122.202 441.646 122.39C441.518 122.579 441.449 122.801 441.449 123.027C441.449 123.331 441.572 123.623 441.79 123.838C442.009 124.053 442.305 124.174 442.614 124.174Z",
    fill: "#ECECEC",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M425.981 143.932C425.981 143.932 426.708 142.208 431.42 142.208H454.272C454.272 142.208 457.106 142.187 458.848 143.768",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M239.383 91.4C239.383 91.4 239.06 100.132 236.242 100.132H231.852V69.373H236.663C236.663 69.373 239.183 71.3591 239.387 77.7447L239.579 83.8445L239.387 91.3954L239.383 91.4Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M253.775 41.4824H209.93V103.818H253.775V41.4824Z",
    fill: "#F7FBFF",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M222.039 94.5675L222.039 54.6106C222.039 48.7522 226.72 44.0001 232.481 44.0001L246.667 44.0001C249.15 44.0001 251.167 46.0493 251.167 48.572L251.167 94.5717C251.167 97.0944 249.15 99.1436 246.667 99.1436L226.538 99.1436C224.056 99.1436 222.039 97.0944 222.039 94.5717L222.039 94.5675Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M239.15 71.5745C239.15 70.1535 238.016 69.0015 236.618 69.0015C235.22 69.0015 234.086 70.1535 234.086 71.5745C234.086 72.9955 235.22 74.1475 236.618 74.1475C238.016 74.1475 239.15 72.9955 239.15 71.5745Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M238.775 71.573C238.775 70.3626 237.809 69.3813 236.618 69.3813C235.427 69.3813 234.461 70.3626 234.461 71.573C234.461 72.7834 235.427 73.7646 236.618 73.7646C237.809 73.7646 238.775 72.7834 238.775 71.573Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M223.762 44.9255L222.826 45.8766C222.575 46.1319 222.575 46.5458 222.826 46.8011L235.301 59.4775C235.552 59.7328 235.96 59.7328 236.211 59.4775L237.147 58.5264C237.398 58.2711 237.398 57.8572 237.147 57.6019L224.672 44.9254C224.421 44.6702 224.013 44.6702 223.762 44.9255Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M222.551 48.381C222.551 48.381 223.042 49.0347 224.06 52.5422C225.636 54.1597 226.25 51.8214 226.25 51.8214C226.25 51.8214 225.813 49.1101 226.122 46.8137",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M222.551 48.381C222.551 48.381 223.042 49.0347 224.06 52.5422C225.636 54.1597 226.25 51.8214 226.25 51.8214C226.25 51.8214 225.813 49.1101 226.122 46.8137",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M226.124 46.8171C226.124 45.5512 225.201 44.5249 224.062 44.5249C222.923 44.5249 222 45.5512 222 46.8171C222 48.0831 222.923 49.1094 224.062 49.1094C225.201 49.1094 226.124 48.0831 226.124 46.8171Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M297.325 46.1016C297.325 46.1016 296.671 46.5923 293.164 47.6109C291.546 49.1863 293.885 49.8008 293.885 49.8008C295.542 49.5501 297.224 49.5072 298.892 49.6729",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M192.91 71.72C193.423 70.6478 193.494 69.277 193.5 68.1103C193.588 65.8785 193.588 55.6316 193.5 53.4006C193.494 52.2331 193.423 50.8614 192.91 49.79",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M184.516 49.6384C194.718 49.9774 190.737 50.2026 199.374 46.7686",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M199.374 74.7424C190.722 71.301 194.716 71.536 184.516 71.873",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M182.914 71.1929C182.962 64.2131 182.962 57.2972 182.914 50.3174",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M174.059 71.3173V50.1943",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M155.461 45.0469L167.943 48.4924C168.724 48.6986 173.407 50.5132 174.142 50.1936C177.447 50.1466 180.961 50.3433 184.262 50.3173",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M155.461 76.4635L167.943 73.0167C168.724 72.8105 173.407 70.9959 174.142 71.3155C177.447 71.3621 180.961 71.1659 184.262 71.1918",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M182.83 75.8408C182.83 75.8408 178.895 75.9443 178.064 76.212L176.168 76.9209C176.028 76.9736 175.897 77.0447 175.776 77.132C175.388 77.4088 174.519 77.9568 174.519 77.9568C173.165 78.5969 171.125 78.7862 169.627 78.9107C168.074 79.0756 166.511 79.1444 164.948 79.1169C162.746 79.0825 160.548 78.9025 158.369 78.5783C157.564 78.4353 156.809 78.0922 156.175 77.5816C155.843 77.1575 155.561 76.6981 155.333 76.212C154.558 75.2562 154.127 74.0739 154.109 72.851V48.6557C154.127 47.4326 154.558 46.2501 155.333 45.2942C155.561 44.8081 155.843 44.3487 156.175 43.9246C156.809 43.414 157.564 43.0709 158.369 42.9279C160.548 42.6037 162.746 42.424 164.948 42.3897C166.511 42.3621 168.074 42.431 169.627 42.5959C171.124 42.7196 173.166 42.9097 174.519 43.5506C174.519 43.5506 175.386 44.0962 175.776 44.3754C175.897 44.4624 176.028 44.533 176.168 44.5853L178.064 45.2946C178.895 45.5639 182.83 45.6683 182.83 45.6683",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M175.758 44.332L175.929 43.8743C175.995 43.7258 176.1 43.5976 176.234 43.5029C176.367 43.4082 176.524 43.3506 176.688 43.3361C177.118 43.3047 181.199 43.0627 182.45 43.0264",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M175.758 77.1768L175.929 77.6349C175.995 77.7829 176.1 77.9108 176.234 78.005C176.368 78.0993 176.524 78.1567 176.688 78.171C177.118 78.2024 181.199 78.4445 182.45 78.4808",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M198.34 44.6604C196.723 42.9411 194.251 42.7221 192.022 42.5213C190.161 42.3015 184.482 42.2454 183.529 42.4413C182.956 42.5593 182.496 42.7927 182.367 43.2661C182.032 44.2851 182.996 45.6811 183.377 46.5863C183.906 47.4523 184.163 48.831 184.264 49.8228C184.379 53.1525 184.363 57.0253 184.35 60.7204V60.7859C184.363 64.481 184.379 68.3538 184.264 71.6835C184.163 72.6753 183.906 74.0523 183.377 74.9204C182.995 75.8256 182.03 77.2216 182.367 78.241C182.496 78.7161 182.956 78.9491 183.529 79.0658C184.482 79.2617 190.161 79.2052 192.022 78.9858C194.251 78.7854 196.723 78.5668 198.34 76.8467C199.613 75.5924 200.329 73.8921 200.33 72.119V49.3881C200.329 47.6149 199.613 45.9146 198.34 44.6604Z",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M192.91 110.931C193.423 109.859 193.494 108.488 193.5 107.321C193.588 105.089 193.588 94.8426 193.5 92.6111C193.494 91.4436 193.423 90.072 192.91 89.001",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M184.516 88.8494C194.718 89.1883 190.737 89.4135 199.374 85.9795",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M199.374 113.953C190.722 110.512 194.716 110.747 184.516 111.084",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M182.914 110.404C182.962 103.424 182.962 96.5081 182.914 89.5283",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M174.059 110.528V89.4053",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M155.461 84.2578L167.943 87.7034C168.724 87.9096 173.407 89.7241 174.142 89.4045C177.447 89.3579 180.961 89.5542 184.262 89.5282",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M155.461 115.674L167.943 112.229C168.724 112.022 173.407 110.208 174.142 110.528C177.447 110.575 180.961 110.377 184.262 110.404",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M182.83 115.052C182.83 115.052 178.895 115.156 178.064 115.423L176.168 116.133C176.028 116.185 175.897 116.256 175.776 116.343C175.388 116.62 174.519 117.166 174.519 117.166C173.165 117.806 171.125 117.995 169.627 118.12C168.074 118.285 166.511 118.354 164.948 118.327C162.746 118.292 160.548 118.112 158.369 117.788C157.564 117.645 156.809 117.302 156.175 116.792C155.843 116.368 155.561 115.908 155.333 115.422C154.558 114.466 154.127 113.284 154.109 112.061V87.8682C154.127 86.6453 154.558 85.4629 155.333 84.5071C155.561 84.021 155.843 83.5616 156.175 83.1376C156.809 82.6269 157.564 82.2839 158.369 82.1408C160.548 81.8167 162.746 81.6369 164.948 81.6026C166.511 81.575 168.074 81.6439 169.627 81.8088C171.124 81.9325 173.166 82.1226 174.519 82.7635C174.519 82.7635 175.386 83.3091 175.776 83.5883C175.897 83.6753 176.028 83.7459 176.168 83.7982L178.064 84.5075C178.895 84.7768 182.83 84.8812 182.83 84.8812",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M175.758 83.5424L175.929 83.0846C175.995 82.9361 176.1 82.8078 176.233 82.713C176.367 82.6183 176.524 82.5606 176.688 82.546C177.118 82.5147 181.199 82.273 182.45 82.2363",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M175.758 116.39L175.929 116.848C175.995 116.996 176.1 117.124 176.234 117.218C176.368 117.312 176.524 117.37 176.688 117.384C177.118 117.415 181.199 117.657 182.45 117.694",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M198.34 83.8713C196.723 82.1516 194.251 81.9331 192.022 81.7322C190.161 81.5124 184.482 81.4564 183.529 81.6522C182.956 81.7702 182.496 82.0036 182.367 82.477C182.032 83.4961 182.996 84.892 183.377 85.7972C183.906 86.6633 184.163 88.0419 184.264 89.0341C184.379 92.3638 184.363 96.2366 184.35 99.9317V99.9973C184.363 103.692 184.379 107.565 184.264 110.895C184.163 111.887 183.906 113.264 183.377 114.132C182.995 115.039 182.03 116.433 182.367 117.453C182.496 117.928 182.956 118.161 183.529 118.278C184.482 118.473 190.161 118.417 192.022 118.198C194.251 117.997 196.723 117.779 198.34 116.058C199.613 114.804 200.329 113.104 200.33 111.331V88.599C200.329 86.8259 199.613 85.1256 198.34 83.8713Z",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M257.384 62.1475H253.777V100.65H257.385L257.384 62.1475Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M226.738 97.8L226.738 70L215.004 70L215.004 97.8L226.738 97.8Z",
    fill: "#D3D3D3"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M216.031 97.7988L215.002 97.7988L215.002 96.2734",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M215 93.5206L215 72.8975",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M215.002 71.5254L215.002 70L216.031 70",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M217.967 70L224.742 70",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M225.709 70L226.738 70L226.738 71.5254",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M226.738 74.2695L226.738 94.8888",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M226.738 96.2734L226.738 97.7988L225.709 97.7988",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M223.773 97.7998L216.998 97.7998",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M276 104H210V163H276V104Z",
    fill: "#F7FBFF",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M320 128H276V163H320V128Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M232.001 103.642V103.998H231.977",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M231 103.999L211 104",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M210.024 104H210V103.644",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M210 102.921V65.7217",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M210 65.3561V65H210.024",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M211 65H231",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M231.977 65H232.001V65.3561",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M232 66.0801V103.28",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M319.945 56.5791V76.4153H425.649V56.5791H319.945Z",
    fill: "#ECECEC",
    stroke: "#707070",
    strokeWidth: 0.5
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M425.652 60.3008V102.365H458.71V60.3008H425.652Z",
    stroke: "#707070",
    strokeWidth: 0.5
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M425.652 102.269V144.333H458.709V102.269H425.652Z",
    stroke: "#707070",
    strokeWidth: 0.5
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M319.945 41.125V56.5799H425.649V41.125H319.945Z",
    fill: "#ECECEC",
    stroke: "#707070",
    strokeWidth: 0.5
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M319.945 128.119V147.955H425.649V128.119H319.945Z",
    fill: "#ECECEC",
    stroke: "#707070",
    strokeWidth: 0.5
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M319.945 147.956V163.411H425.649V147.956H319.945Z",
    fill: "#ECECEC",
    stroke: "#707070",
    strokeWidth: 0.5
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M418.526 78.5811H324.975C322.255 78.5811 320.051 80.7505 320.051 83.4267V121.107C320.051 123.784 322.255 125.953 324.975 125.953H418.526C421.245 125.953 423.45 123.784 423.45 121.107V83.4267C423.45 80.7505 421.245 78.5811 418.526 78.5811Z",
    stroke: "#707070",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarStype);
export default __webpack_public_path__ + "static/media/car_stype.616132bc3edce809ef17dc227dbf8114.svg";
export { ForwardRef as ReactComponent };